import React from 'react';

const Root = () => <React.Fragment></React.Fragment>;

export default Root;
